import React, { useState } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import { useFormik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import swal from "sweetalert";
import Logo from '../images/logo.png';
import OtpInput from "react-otp-input";


export default function Login() {
  const [inputs, setInputs] = useState({});
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const handleChange = (code) => {
    setCode(code)
    setInputs({
      otp: code,
      id: localStorage.getItem("id"),
      email: localStorage.getItem("email"),
      password: localStorage.getItem("password"),
    })
  };

  //Timer code start
  var OTP_COUNTER= localStorage.getItem("otpCounter") == null ? 59 : localStorage.getItem("otpCounter")
  const [counter, setCounter] = React.useState(OTP_COUNTER);
  React.useEffect(() => {
    const timer =
    counter > 0 && setInterval(() => {
      localStorage.setItem("otpCounter", counter);
      setCounter(counter - 1)
      console.log("COUNT: ", counter);
    }, 1000);
    return () => clearInterval(timer);
  }, [counter]);
//Timer code end


  function handleSubmit(event){
    event.preventDefault();
      
    axios.post(process.env.REACT_APP_API_KEY + "api/admin/otp-validate", inputs)
        .then((res) => {
          if (res.status === 200) {
            swal({
              title: "Wow!",
              text: res.data.message,
              icon: "success",
              button: "Okay",
            });
            
            localStorage.clear();
            localStorage.setItem("token", res.data.token);
            //localStorage.removeItem("otpCounter")
            return navigate("/admin/dashboard");
          } 
        }).catch(error => {
            swal("Oops", error.response.data.message, "error");
      });
  }

  const resendOtp = async (id) => {
    await axios.get(process.env.REACT_APP_API_KEY+'api/admin/otp-resend/'+id,
      {
        headers: {
        "Content-type": "Application/json",
        }   
      }
      ).then(function (response) {
      console.log("----->", response.data.message);
      if(response.status===200)
      {
        setCounter(59);
        swal({
          title: "Status",
          text: response.data.message,
          icon: "success",
          button: "Okay",
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  return (
    <>
    <div className="login">
        <div className="App">
        <img src={Logo} className="logo" alt="Business view - Reports" />
        {/* {<form className="form" onSubmit={handleSubmit}>} */}
          <div className="input-group otp-input">
            <div className='timer'><div><label htmlFor="OTP">OTP Verification</label></div> <p>{ counter > 1 ? "OTP valid till: " + counter : "" } </p></div>
            <div className='mt-3'>
            <OtpInput
              value={code}
              onChange={handleChange}
              numInputs={6}
              separator={<span style={{ width: "8px" }}></span>}
              isInputNum={true}
              shouldAutoFocus={true}
              inputStyle={{
                border: "1px solid black",
                borderRadius: "8px",
                width: "54px",
                height: "54px",
                fontSize: "14px",
                color: "#000",
                fontWeight: "400",
                caretColor: "blue",
              }}
              focusStyle={{
                border: "1px solid black",
                outline: "none"
              }}
            />
            </div>
          </div>
          <button className="primary" onClick={handleSubmit}>Submit</button>
          <a href='javascript:void(0)' onClick={() => { resendOtp(localStorage.getItem("id")); }} className="resend-link">Resend OTP</a>
          
        {/* {</form>} */}
      </div>
    </div>
    </>
  )
}